import React, {useState, useEffect, useRef} from 'react';
import _ from '../../utils/_';

import ProductCard from '../cards/product-card/product-card';
import ArtistCard from '../cards/artist-card/artist-card';
import Arrow from '../icons-af/arrow';
import useCarouselScroll from '../../hooks/use-carousel-scroll/use-carousel-scroll';
import elementFactory from '../../utils/element';
import '../carousel-scroll/carousel-scroll.scss';
import './product-carousel-related.scss';

// todo: extract to constants
const CARD_WIDTH_SM = 172 + 10;
const CARD_WIDTH_LG = 270 + 10;

const ProductCarouselRelated = ({
  type,
  items,
  small = false,
  imageType,
  isAttraqt,
  onProductClick = null,
  onAddProductToBasket = null,
}: propTypes) => {
  const [step, setStep] = useState(6);
  const target = useRef(null);
  const [active, setActive] = useState(0);
  const steps = _.range(0, Math.ceil(items.length / step));
  const CARD_WIDTH = small ? CARD_WIDTH_SM : CARD_WIDTH_LG;

  useCarouselScroll(target, {step, onScroll: setActive}, [items, step]);

  useEffect(() => {
    const $ = elementFactory(document, window);
    const onResize = _.debounce(false, 150, () => {
      setStep(Math.floor($.innerWidth(target.current) / CARD_WIDTH));
    });

    onResize();

    $.on('resize', onResize, window);
    return () => {
      $.off('resize', onResize, window);
    };
  }, []);

  return (
    <div ref={target} className="carousel-scroll product-carousel-related">
      <div className="carousel-scroll-outer">
        {items.length > 0 && (
          <div className="carousel-scroll-inner">
            {type === 'product'
              ? items.map((x, i) => (
                  <div key={i} className="carousel-scroll-item">
                    <ProductCard
                      product={x}
                      small={small}
                      imageType={imageType}
                      isAttraqt={isAttraqt}
                      onClick={onProductClick}
                      onAddToBasket={onAddProductToBasket}
                    />
                  </div>
                ))
              : items.map((el, i) => (
                  <div key={i} className="carousel-scroll-item">
                    <ArtistCard artist={el} />
                  </div>
                ))}
          </div>
        )}
      </div>
      <br />
      <a
        className={'carousel-scroll-control-prev' + (active <= 0 ? ' disabled' : '')}
        href="#"
        role="button"
      >
        <span className="carousel-scroll-control-prev-icon" aria-hidden="true">
          <Arrow height="100%" width="24px" rotate={180} />
        </span>
        <span className="sr-only">{'Previous'}</span>
      </a>
      <a
        className={'carousel-scroll-control-next' + (active >= steps.length - 1 ? ' disabled' : '')}
        href="#"
        role="button"
      >
        <span className="carousel-scroll-control-next-icon" aria-hidden="true">
          <Arrow height="100%" width="24px" />
        </span>
        <span className="sr-only">{'Next'}</span>
      </a>

      <ol className="carousel-scroll-indicators">
        {steps.map((_, i) => (
          <li key={i} data-slide-to={i}></li>
        ))}
      </ol>
    </div>
  );
};

interface propTypes {
  type: 'product' | 'artist';
  items: any[];
  small?: boolean;
  getImage?: (item) => any;
  imageType?: 'artwork' | 'in room' | 'main';
  isAttraqt?: boolean;
  onProductClick?: any;
  onAddProductToBasket?: any;
}

export default ProductCarouselRelated;
